import { HeroPrimary2Type } from "../../types/heroTypes"
import { API } from "../../constants/constants"
import BaseHeadline from "../common/BaseHeadline"
import BaseRichtext from "../common/BaseRichtext"
import BaseQuoteText from "../common/BaseQuoteText"
import { Swiper, SwiperSlide } from "swiper/react"
import SwiperCore from "swiper"
import { Autoplay } from "swiper/modules"
import "swiper/css"
import { ReactComponent as BLUR } from "../../assets/blur.svg"

export default function HeroPrimary2(props: HeroPrimary2Type) {
    SwiperCore.use([Autoplay])

    const getShade = (shade?: string): string => {
        if (shade?.includes("heroPrimary2WelcomeQuoteColorLight")) return "bg-base-200"
        if (shade?.includes("heroPrimary2WelcomeQuoteColorSuperLight")) return "bg-base-300"
        if (shade?.includes("heroPrimary2WelcomeQuoteColorWhite")) return "bg-accent"
        if (shade?.includes("heroPrimary2WelcomeQuoteColorPrimary")) return "bg-base-100"
        if (shade?.includes("heroPrimary2WelcomeQuoteColorOptional")) return "bg-info"
        return ""
    }

    return (
        <div className="w-full pb-4">
            {/* UPPER PART */}
            <div className="w-full h-[70vh] bg-cover bg-center flex items-end rounded-t-xl -mb-4 relative">
                <Swiper
                    autoplay={{ delay: 5000, disableOnInteraction: false }}
                    loop={true}
                    navigation={false}
                    className="!absolute !inset-0 !w-full !h-full">
                    {props.heroPrimary2Background?.map((slide, index) => {
                        const media = slide.heroPrimary2BackgroundImage
                        return (
                            <SwiperSlide key={index} className="">
                                {media.isVideo ? (
                                    <video
                                        className="w-full h-full object-cover"
                                        autoPlay
                                        loop
                                        muted
                                        playsInline
                                        webkit-playsinline
                                    >
                                        <source src={API + media.url} type={media.mimeType} />
                                        Your browser does not support the video tag.
                                    </video>
                                ) : (
                                    <img className="w-full h-full object-cover" src={API + media.url} alt={media.description ?? media.name} />
                                )}
                            </SwiperSlide>
                        )
                    })}
                </Swiper>
                <div className="relative pb-16 md:pb-24 px-4 md:pl-8 w-full h-full flex flex-col items-start justify-end bg-gradient-to-tr from-base-200 via-transparent to-transparent rounded-tr-full z-[6]">
                    <BaseHeadline headlineType={1} label={props?.heroPrimary2Heading} classProps="!text-primary relative z-[11]" />
                    <BaseRichtext content={props.heroPrimary2Text} classProps="font-semibold !text-primary relative z-[11]" />
                </div>
                <BLUR className="absolute h-[70vh] fill-base-200 z-[5] inset-0" />
                <BLUR className="absolute h-[70vh] fill-base-200 z-[5] inset-0" />
                <BLUR className="hidden sm:block absolute h-[70vh] fill-base-200 z-[5] inset-0" />
            </div>
            <div className="w-full bg-base-200 rounded-default pt-16 py-48 -mb-32 relative z-10">
                <div className="max-w-content mx-auto">
                    <div className="flex flex-col md:flex-row items-center gap-8 px-4">
                        <div className="">
                            <BaseRichtext content={props.heroPrimary2WelcomeText} classProps="pb-4" />
                            <img
                                src={API + props.heroPrimary2WelcomeIcon?.url}
                                alt={props.heroPrimary2WelcomeIcon?.description ?? props.heroPrimary2WelcomeIcon.name ?? "WelcomeIconAlt"}
                                className="w-24 mx-auto"
                            />
                        </div>
                        <img
                            src={API + props.heroPrimary2WelcomeImage?.url}
                            alt={props.heroPrimary2WelcomeImage?.description ?? props.heroPrimary2WelcomeImage.name ?? "HeroPrimaryWelcomeImage"}
                            className="w-full h-64 md:h-auto md:w-1/2 md:aspect-square object-cover border-4 border-primary rounded-default flex-shrink-0"
                        />
                    </div>
                </div>
            </div>
            <div className={`max-w-content w-full mx-auto pt-16 pb-12  flex flex-col px-4 items-start gap-2 rounded-default relative z-10 ${getShade(props.heroPrimary2WelcomeQuoteColor) || 'bg-base-100'}`}>
                <BaseQuoteText
                    text={props.heroPrimary2WelcomeQuote}
                    author={props.heroPrimary2WelcomeQuoteAuthor}
                    isQuoteWhite={props.heroPrimary2SettingQuoteColor}
                />
            </div>
        </div>
    )
}
